import { render, staticRenderFns } from "./AlertCpt.vue?vue&type=template&id=4829b059&scoped=true&"
import script from "./AlertCpt.vue?vue&type=script&lang=js&"
export * from "./AlertCpt.vue?vue&type=script&lang=js&"
import style0 from "./AlertCpt.vue?vue&type=style&index=0&id=4829b059&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4829b059",
  null
  
)

export default component.exports